import React, { useState } from 'react';
import Notification from '../components/common/notification';

export const NotificationContext = React.createContext();

export const NotificationProvider = (props) => {
  const [notifications, setNotifications] = useState([]);

  function addNotification(options) {
    setNotifications((nots) => [...nots, { id: Math.random(), ...options }]);
  }

  function removeNotification(id) {
    setNotifications((nots) => nots.filter((not) => not.id !== id));
  }

  const options = {
    error: (options) => addNotification({ ...options, type: 'error' }),
    success: (options) => addNotification({ ...options, type: 'success' }),
  };

  return (
    <NotificationContext.Provider value={options} {...props}>
      {notifications.map((not, index) => (
        <Notification
          key={`notification-${index}`}
          {...not}
          onClose={removeNotification}
        />
      ))}
      {props.children}
    </NotificationContext.Provider>
  );
};
